<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<TableFuncs>
				<Button class="mr" type="primary" icon="ios-add-circle-outline" @click="addSchoolJobShow">新增广告图</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<Button v-if="row.status=='1'" type="warning" size="small" style="margin-right: 5px"
						@click="updateSchoolStatus(row.id,0)">停用</Button>
					<Button v-if="row.status=='0'" type="success" size="small" style="margin-right: 5px"
						@click="updateSchoolStatus(row.id,1)">启用</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addJobShow" :title="addForm.id?'编辑':'新增'" width="600">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">

				<FormItem label="轮播图片" prop="imgUrl">
					<Upload :action="uploadFile" name="file" :on-success="logoImgBack" :data="uploadData"
						accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传图片</Button>
					</Upload>
				</FormItem>
				<FormItem label="落地页链接">
					<Input v-model="addForm.linkUrl" maxlength="100" placeholder="请输入落地页链接" clearable></Input>
				</FormItem>
				<FormItem label="展示类型" prop="showType">
					<RadioGroup v-model="addForm.showType">
						<Radio label="1">banner</Radio>
						<Radio label="2">弹窗</Radio>
						<Radio label="3">开屏</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="展示时间" prop="startTime">
					<DatePicker type="datetimerange" v-model="addForm.dateTimeRange" format="yyyy-MM-dd HH:mm:ss" placement="bottom-end"
						placeholder="请选择" style="width:80%" />
				</FormItem>
				<FormItem label="app渠道" prop="appChannel">
					<RadioGroup v-model="addForm.appChannel">
						<Radio label="1">兼职直聘</Radio>
						<Radio label="2">校园直聘</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="状态">
					<i-switch v-model="addForm.status==1" size="large" @on-change="changeStatus($event,item)">
						<span slot="open">启用</span>
						<span slot="close">停用</span>
					</i-switch>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrEditData">确认提交</Button>
			</div>
		</Modal>


	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition8'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				uploadFile: api.statistics.uploadFile,
				uploadData: {
					filePath: 'img'
				},
				queryParams: {

				},
				codeImgs: [],
				addJobShow: false,
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addForm: {
					id: undefined,
					imgUrl: '',
					linkUrl: '',
					showType:undefined,
					dateTimeRange: [],
					startTime:undefined,
					endTime:undefined,
					status: 0,
					appChannel: undefined,
				},
				addRule: {
					imgUrl: [{
						required: true,
						message: '请上传图片',
						trigger: 'blur',
					}],
					showType: [{
						required: true,
						message: '展示类型不能为空',
						trigger: 'blur',
					}],
					startTime: [{
						required: true,
						message: '展示时间不能为空',
						trigger: 'blur',
					}],
					appChannel: [{
						required: true,
						message: 'app渠道不能为空',
						trigger: 'blur',
					}]
				},
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '图片链接',
						width: 350,
						key: 'imgUrl',
						align: 'center'
					},
					{
						title: '落地页链接',
						width: 350,
						key: 'linkUrl',
						align: 'center'
					},
					{
						title: '展示类型',
						width: 120,
						align: 'center',
						render: (h, params) => {
							let name="";
							let val = params.row.showType;
							if (val == 1) {
								name = 'banner'
							} else if(val==2){
								name = '弹窗'
							}else if(val==3){
								name = '开屏'
							}
							return h('span', name)
						}
					},
					{
						title: '展示时间',
						width: 350,
						align: 'center',
						render: (h, params) => {
							let data = params.row;
							let name=data.startTime+"|"+data.endTime;							
							return h('span', name)
						}
					},
					{
						title: '状态',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.status;
							if (val == 1) {
								name = '启用'
							} else {
								name = '停用'
							}
							return h('span', name)
						}
					},
					{
						title: 'app渠道',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.appChannel;
							if (val == 1) {
								name = '兼职直聘'
							} else {
								name = '校园直聘'
							}
							return h('span', name)
						}
					}, {
						title: '创建日期',
						key: 'updateTime',
						align: 'center',
						width: 200,
					}, {
						title: '操作',
						slot: 'action',
						width: 250,
						align: 'center'
					}

				]
			},

		},
		created() {
			this.getData();
		},
		methods: {
			change() {

			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.jobAdvertImgPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			logoImgBack(response, file, fileList) {
				this.addForm.imgUrl = response.data.url
			},
			addSchoolJobShow() {
				this.addForm = {
					id: undefined,
					imgUrl: '',
					linkUrl: '',
					showType:undefined,
					dateTimeRange: [],
					startTime:undefined,
					endTime:undefined,
					status: 0,
					appChannel: undefined,
				}
				this.addJobShow = true
			},
			addOrEditData(row) {
				const that = this
				let addData = this.addForm
				if(addData.dateTimeRange.length==2){
					addData.startTime=that.util.formatDateTime(addData.dateTimeRange[0])
					addData.endTime=that.util.formatDateTime(addData.dateTimeRange[1])
				}
				console.log(addData)
				that.$refs['addForm'].validate((valid) => {
					if (valid) {				
						api.statistics
							.addOrEditAdvertImg(addData)
							.then(res => {
								that.addJobShow = false
								that.refreshData()
							})
					}
				})
			},
			changeStatus(state, data) {
				this.addForm.status = state ? '1' : '0'
			},
			updateSchoolStatus(id, status) {
				const that = this
				api.statistics
					.updateAdvertImgStatus({
						'id': id,
						status: status
					})
					.then(res => {
						that.$Message.success('Success!');
						that.queryData.forEach(item => {
							if (item.id == id) {
								item.status = status
							}
						})
					})
			},
			editData(data) {
				this.addForm = data
				this.addJobShow = true
			},

		},

	}
</script>
<style>
	.detail {
		display: flex;
		flex-direction: row;
	}
</style>